module.exports = __webpack_public_path__ + "img/miniapp_code.jpg";